"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptionText = exports.Header = exports.StateBlockButton = exports.IconWrapper = exports.Wrapper = void 0;
const button_1 = require("@pulse-web-ui/button");
const theme_1 = require("@pulse-web-ui/theme");
exports.Wrapper = theme_1.styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
exports.IconWrapper = theme_1.styled.div `
  margin-bottom: 16px;
`;
exports.StateBlockButton = (0, theme_1.styled)(button_1.Button) `
  width: 100%;
  max-width: 328px;
`;
exports.Header = theme_1.styled.h1 `
  ${theme_1.typography.medium24};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-top: 0;
  margin-bottom: 26px;
  text-align: center;
`;
exports.DescriptionText = theme_1.styled.p `
  ${theme_1.typography.regular16}
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 0;
  text-align: center;
`;
